import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from '../store.service';
import { PlatformLocation } from '@angular/common';
import { CommonService } from '../common.service';
import { getErrorMsg, hasFormalLoginToken, isCompanyAccountInvalid, isCompanySelectionExpired } from '../login-error.util';
var CourseSelectComponent = (function () {
    function CourseSelectComponent(apiService, store, commonService, router, route, platformLocation) {
        this.apiService = apiService;
        this.store = store;
        this.commonService = commonService;
        this.router = router;
        this.route = route;
        this.platformLocation = platformLocation;
        this.assetsRoute = "../../assets";
        this.courseList = [];
        this.loginData = {};
        this.isEnter = false; //是否进入
        this.isInitialSelect = false;
        this.selecting = false;
        this.tipMessage = '';
        this.messageBoxOpen = false;
    }
    CourseSelectComponent.prototype.openMessageBox = function (message) {
        var _this = this;
        if (message) {
            this.tipMessage = message;
        }
        this.messageBoxOpen = true;
        setTimeout(function () {
            _this.messageBoxOpen = false;
        }, 2000);
    };
    CourseSelectComponent.prototype.handleItemClick = function (data) {
        var _this = this;
        if (this.selecting) {
            return;
        }
        localStorage.setItem('themeBG', data.type);
        console.log('点击了', data.id);
        var currentToken = localStorage.getItem('transtalen-token');
        var isSwitch = !this.isInitialSelect && !!currentToken;
        var sendData;
        if (isSwitch) {
            sendData = this.commonService.buildCompanyReloginPayload(this.loginData, data.id, {
                switchCompany: true,
                token: currentToken
            });
        }
        else {
            var selectionToken = this.loginData && this.loginData.companySelectionToken;
            if (!selectionToken) {
                this.router.navigate(['new-login']);
                return;
            }
            sendData = this.commonService.buildPhoneCompanySelectPayload(data.id, selectionToken);
        }
        console.log(sendData);
        this.selecting = true;
        this.apiService.loginInPhoneOrAccount(sendData, { withToken: isSwitch }).subscribe(function (res) {
            _this.selecting = false;
            console.log(res, '多学员登录返回数据----------------------------------');
            if (hasFormalLoginToken(res)) {
                localStorage.setItem('transtalen-token', res.token);
                if (res.userIdEncoder) {
                    localStorage.setItem('transtalenuserid', res.userIdEncoder);
                }
                _this.apiService.setHeaders(); //header设置
                if (_this.loginData) {
                    delete _this.loginData.protectionChallengeToken;
                    delete _this.loginData.companySelectionToken;
                }
                var rawLoginData = localStorage.getItem('loginData');
                if (rawLoginData) {
                    try {
                        var stored = JSON.parse(rawLoginData);
                        delete stored.protectionChallengeToken;
                        delete stored.companySelectionToken;
                        localStorage.setItem('loginData', JSON.stringify(stored));
                    }
                    catch (e) { }
                }
                if (_this.isOpenClass === 1) {
                    _this.platformLocation['location']['href'] = _this.platformLocation['location']['origin'] + '/ddilearner/v1/user/authorize?token=' + res.token + '&' + _this.targetUrl;
                }
                else {
                    _this.router.navigate(['learning-map', '-1']);
                }
            }
            else {
                _this.router.navigate(['new-login']);
            }
        }, function (error) {
            _this.selecting = false;
            var message = getErrorMsg(error);
            if (isCompanyAccountInvalid(message)) {
                _this.openMessageBox(message || '该公司账号已失效');
                return;
            }
            if (isCompanySelectionExpired(message)) {
                _this.commonService.clearCompanySelectionState();
                _this.openMessageBox(message || '登录验证已失效，请重新验证');
                _this.router.navigate(['new-login']);
                return;
            }
            _this.openMessageBox(message || '登录失败，请重试');
        });
    };
    CourseSelectComponent.prototype.handleCompanyList = function (orignCompanyList) {
        var courseList = [];
        orignCompanyList.forEach(function (element) {
            var type = element.companiesType;
            var item = {
                type: 'company',
                title: '公司课程',
                description: element.name,
                id: element.id,
                state: element.state,
                name: element.name
            };
            if (type == 1) {
                item.type = 'open';
                item.title = '公开课';
            }
            else if (type == 2) {
                item.type = 'experience';
                item.title = '体验课';
            }
            if (item.state === 1) {
                courseList.push(item);
            }
        });
        this.courseList = courseList;
    };
    CourseSelectComponent.prototype.hasCachedCompanyList = function () {
        var cachedList = this.loginData && this.loginData.companyList;
        return Array.isArray(cachedList) && cachedList.filter(function (item) { return item.state === 1; }).length > 1;
    };
    CourseSelectComponent.prototype.hasSelectionToken = function () {
        return !!(this.loginData && this.loginData.companySelectionToken);
    };
    CourseSelectComponent.prototype.getCompanyList = function () {
        var _this = this;
        try {
            this.loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
        }
        catch (e) {
            this.loginData = {};
        }
        if (this.loginData && this.loginData.password) {
            this.loginData.password = this.commonService.xorDecrypt(this.loginData.password, this.commonService.xorKey);
        }
        this.route.queryParams.subscribe(function (params) {
            _this.isInitialSelect = 'notSelectCompany' in params;
            var hasToken = !!localStorage.getItem('transtalen-token');
            if (_this.isInitialSelect) {
                if (_this.hasCachedCompanyList() && _this.hasSelectionToken()) {
                    _this.handleCompanyList(_this.loginData.companyList);
                }
                else {
                    _this.router.navigate(['new-login']);
                }
                return;
            }
            if (!hasToken) {
                if (_this.hasCachedCompanyList() && _this.hasSelectionToken()) {
                    _this.isInitialSelect = true;
                    _this.handleCompanyList(_this.loginData.companyList);
                }
                else {
                    _this.router.navigate(['new-login']);
                }
                return;
            }
            _this.apiService.getCompanyList().subscribe(function (result) {
                if (Array.isArray(result) && result.filter(function (item) { return item.state === 1; }).length > 1) {
                    _this.handleCompanyList(result);
                }
                else {
                    _this.router.navigate(['/learning-map']);
                }
            });
        });
    };
    CourseSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.targetUrl = localStorage.getItem('targetUrl') ? localStorage.getItem('targetUrl') : null;
        this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
        this.getCompanyList();
        setTimeout(function () {
            _this.isEnter = true;
        }, 200);
    };
    CourseSelectComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': '#F5F5F5'
        });
    };
    return CourseSelectComponent;
}());
export { CourseSelectComponent };



// WEBPACK FOOTER //
// ./src/app/course-select/course-select.component.ts.pre-build-optimizer.js